"use strict";

angular.module("licensure.services").factory("Session", [
    "$http",
    "$q",
    function ($http, $q) {
        return {
            checkIn: function () {
                var d = $q.defer();

                $http({
                    method: "PUT",
                    url: apiLocation + "/api/session/checkin",
                    data: {}
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            CheckSession: function () {
                var d = $q.defer();

                $http({
                    method: "GET",
                    url: apiLocation + "/api/session/CheckSession",
                    data: {}
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },


            expireSession: function (isPortal) {
                var d = $q.defer();

                $http({
                    method: "PUT",
                    url: apiLocation + "/api/session/expireSession",
                    params: { isPortal: isPortal }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error

                    });

                return d.promise;
            },

            IsSessionAlive: function (isPortal) {
                var d = $q.defer();

                $http({
                    method: "GET",
                    url: apiLocation + "/api/session/IsSessionAlive",
                    params: { isPortal: isPortal }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            },
        };
    }
]);
